/**
 * Returns today's date as YYYY-MM-DD in the user's LOCAL timezone.
 * Use for all daily activity tracking (focus items, daily points, mood history,
 * activity day docs, wellness message freshness).
 *
 * All users are US-based. The browser's local timezone is authoritative on the
 * client side. The backend falls back to US Eastern when localDate is missing.
 */
export const getLocalDateString = (date: Date = new Date()): string => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

/** Today's date as YYYY-MM-DD in UTC. Use for insights and other UTC-calendar features. */
export const getUtcDateString = (date: Date = new Date()): string => {
    const y = date.getUTCFullYear();
    const m = String(date.getUTCMonth() + 1).padStart(2, '0');
    const d = String(date.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};
